// Element
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/styles/common.scss'
// btky平台字体库
import '@/assets/fonts/iconfont.css'
// 工具类
import Utils from '@/utils/util'
import * as UtilsCommon from '@/utils/index'
import { frontExport } from '@/utils/frontExport'
// global filters 全局过滤
import * as filters from '@/filters'
// 通用组件
import '@/components'
import * as R from 'ramda'

import { Plugin } from 'vue-fragment'
import directives from '../directives'
export default {
  async install(Vue, options) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示。
    // https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false
    // 注册Element UI
    Vue.use(ElementUI)
    // 注册全局过滤器（register global utility filters. ）
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })

    Vue.prototype.$message = function(option) {
      return Message({
        duration: 6000,
        showClose: true,
        ...option
      })
    }
    Vue.prototype.$message.error = function(option) {
      if (typeof option === 'string') {
        return Message.error({
          duration: 6000,
          showClose: true,
          message: option
        })
      }
      return Message.error({
        duration: 6000,
        showClose: true,
        ...option
      })
    }
    Vue.prototype.$message.success = function(option) {
      if (typeof option === 'string') {
        return Message.success({
          duration: 6000,
          showClose: true,
          message: option
        })
      }
      return Message.success({
        duration: 6000,
        showClose: true,
        ...option
      })
    }

    Vue.prototype.$message.warning = function(option) {
      if (typeof option === 'string') {
        return Message.warning({
          duration: 6000,
          showClose: true,
          message: option
        })
      }
      return Message.warning({
        duration: 6000,
        showClose: true,
        ...option
      })
    }

    Vue.prototype.R = R
    // 插件
    Vue.use(Plugin)
    Vue.use(directives)
    // 使用帮助类
    Vue.prototype.$utils = Utils
    Vue.prototype.$utilsCommon = UtilsCommon
    // 快速打印 log
    Vue.prototype.$log = Utils.log
    // 前端导出
    Vue.prototype.$frontExport = frontExport
  }
}



// WEBPACK FOOTER //
// ./src/plugins/index.js